import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useSnackbar } from 'notistack';
import { LoanP2PShowModal } from './LoansP2PModal';
import { getLoanP2PKeyByID } from '../../../redux/loans_p2p_key/thunks';
import { LoanStatus } from '../../../domain/constants/LoanStatus';
import { StatusP2POptionVerbo } from '../../../domain/constants/StatusP2PTransfer';
import { useNavigate } from 'react-router-dom';

type LoanP2PModalProps = {
  p2p_transfer_id: number | null;
  target_user_id?: number | null;
  p2p_transfer_status_id: number;
  open?: boolean;
  onClose: Function;
};

const getStatusStringVerb = (id: number) => {
  let obj = StatusP2POptionVerbo.find((item) => item.id === id);
  return obj?.name;
};

export const LoanP2PModal = ({
  p2p_transfer_id,
  target_user_id,
  p2p_transfer_status_id,
  open,
  onClose,
}: LoanP2PModalProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate(); // habilitar navigate para redirección

  const { loans_p2p_key, loading } = useAppSelector(
    (state) => state.loans_p2p_key
  );
  const dispatch = useAppDispatch();
  const [loadedLoanP2PKey, setLoanP2PKey] = useState<boolean>(true);
  const [selectedHousekey, setSelectedHousekey] = useState<number>(-1);
  const [filter, setFilter] = useState('');
  //realiza la consulta de p2p
  const updateDataByPagination = async () => {
    if (p2p_transfer_id && !loading && open) {
      setLoanP2PKey(false);
      dispatch<any>(getLoanP2PKeyByID(`&p2p_transfer_id=${p2p_transfer_id}`))
        .unwrap()
        .then(() => {
          setSelectedHousekey(p2p_transfer_id);
          setLoanP2PKey(true);
        });
    }
  };
  useEffect(() => {
    updateDataByPagination();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [p2p_transfer_id]);

  const aceptOrReject = (_transaction_id: number, _newStatus: LoanStatus) => {
    navigate(`/p2p/loans`, { replace: true });
    onClose(false);
  };
  return (
    <>
      {loadedLoanP2PKey && (
        <LoanP2PShowModal
          loans_p2p_key_list={loans_p2p_key}
          title={`Llaves ${getStatusStringVerb(p2p_transfer_status_id)} por ${
            loans_p2p_key.period_min || ''
          } días`}
          aceptOrReject={aceptOrReject}
          onClose={onClose}
          transfer_id={p2p_transfer_id}
          target_user_id={target_user_id}
          p2p_transfer_status_id={p2p_transfer_status_id}
        />
      )}
    </>
  );
};
